module.exports = __webpack_public_path__ + "img/54584E_B1BAC5_818B91_A7ACA3-256px.282769ce.png";